import { useState } from "react";
import Popper from "../components/popper";
import "../utils/tailwind.css";
import ProfilePicture from "./components/profile-picture";
import Modal from "../components/modal";
import { useStore } from "../utils/context";
import { useNavigate, useLocation } from "react-router-dom";
import Const from "../utils/constant";
import { LogOut, ChevronLeft, Menu } from "lucide-react";
import RasaLogo from "../assets/images/rasalogo1.png";

export default function AppNavbar({ onMenuClick }) {
  const [isPopperOpen, setIsPopperOpen] = useState(false);
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const { handleLogout, user } = useStore();
  const [isModalOpen, setIsOpenModal] = useState(false);

  const handleLogoutClick = () => {
    handleLogout();
  };

  const location = useLocation();
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  const showBackButton = (pathname) => {
    if (Const.BACK_BUTTON_SCREENS.includes(pathname)) return true;
    return Const.BACK_BUTTON_SCREENS.some((pattern) => {
      const regex = new RegExp(`^${pattern.replace(":id", "\\d+")}$`);
      return regex.test(pathname);
    });
  };

  const getPageTitle = () => {
    const path = location.pathname.replace("/", "");
    const menuItem = [...Const.MENU_ITEMS.PAGES, ...Const.MENU_ITEMS.MASTER_PAGES, ...Const.MENU_ITEMS.MISC].find(
      (item) => item.link === location.pathname
    );
    return menuItem?.label || path.charAt(0).toUpperCase() + path.slice(1);
  };

  return (
    <>
      <nav className="!fixed !top-0 !left-0 !right-0 !w-full !max-w-none !z-[9999] !h-[68px] !bg-[#1a1a4e] border-b border-white/10 shadow-lg !flex !flex-row !justify-between !items-center !px-6 !m-0 !p-0">

        <div className="!flex !items-center !flex-shrink-0 !h-full">
          <button
            onClick={onMenuClick}
            className="lg:hidden rounded-lg pr-2 hover:bg-white/10 text-white transition-colors"
          >
            <Menu size={24} />
          </button>

          <div className="!flex !items-center !gap-4 !pr-4 !border-r !border-white/40 hidden sm:flex !h-[40px]">
            <img src={RasaLogo} alt="Rasa Enclave" className="h-12 w-14 object-contain" />
            <div className="hidden md:block">
              <div className="text-white font-semibold text-[13px] tracking-widest leading-none">RASA ENCLAVE</div>
              <div className="text-white/40 text-[9px] uppercase tracking-[2px] mt-1">Admin Panel</div>
            </div>
          </div>

          <div className="!flex !items-center !gap-4 !ml-2">
            {showBackButton(location.pathname) && (
              <button
                onClick={handleGoBack}
                className="!flex !items-center !gap-1.5 !px-3 !py-1.5 !rounded-lg !text-white/80 hover:text-white hover:bg-white/10 !transition-all !text-sm !font-medium"
              >
                <ChevronLeft size={18} />
                <span>Back</span>
              </button>
            )}
            <h1 className="!text-white !font-semibold !text-base md:!text-lg !leading-tight !ml-6">
              {getPageTitle()}
            </h1>
          </div>
        </div>

        <div className="!flex !items-center !gap-4 !flex-shrink-0 !h-full !pr-2">
          {/* <button
            onClick={() => setIsDrawerOpen(true)}
            className="p-2 rounded-lg hover:bg-white/10 text-white/70 hover:text-white transition-colors relative"
          >
            <Bell size={20} />
            <span className="absolute top-2 right-2 w-2 h-2 bg-[#FCBB32] rounded-full border-2 border-[#1a1a4e]"></span>
          </button> */}

          <Popper placement="bottom" setIsOpen={setIsPopperOpen} isOpen={isPopperOpen} onOutsideClick={() => setIsPopperOpen(false)}>
            <Popper.Trigger>
              {({ setAnchorElement }) => (
                <div ref={setAnchorElement}>
                  <div
                    onClick={() => setIsPopperOpen(true)}
                    className="!flex !items-center !gap-3 !pl-3 !pr-1 !py-1 !rounded-xl hover:bg-white/5 !transition-all !cursor-pointer group !border !border-transparent hover:!border-white/10"
                    title="Account"
                  >
                    <div className="hidden md:block text-right">
                      <div className="text-white text-xs font-bold leading-none uppercase tracking-wider">Admin</div>
                      <div className="text-white/40 text-[10px] mt-1 truncate max-w-[120px]">
                        {user?.email || "rasa@admin.com"}
                      </div>
                    </div>
                    <div className="!w-10 !h-10 !rounded-lg !bg-[#FCBB32] !flex !items-center !justify-center !text-[#1a1a4e] !font-black !text-base !shadow-lg group-hover:scale-105 !transition-transform">
                      {user?.email ? user.email.charAt(0).toUpperCase() : "A"}
                    </div>
                  </div>
                </div>
              )}
            </Popper.Trigger>
            <Popper.Content>
              <div className="bg-white rounded-xl border border-gray-100 shadow-2xl p-2 min-w-[220px] mt-3 mr-4">
                <div className="px-4 py-3 border-b border-gray-50 mb-1">
                  <div className="text-gray-900 font-bold text-sm">Administrator</div>
                  <div className="text-gray-400 text-xs truncate mt-0.5">{user?.email || "rasa@admin.com"}</div>
                </div>
                <button
                  className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-red-500 hover:bg-red-50 font-semibold text-sm transition-colors"
                  onClick={() => {
                    setIsPopperOpen(false);
                    setIsOpenModal(true);
                  }}
                >
                  <LogOut size={16} />
                  Logout System
                </button>
              </div>
            </Popper.Content>
          </Popper>
        </div>
      </nav>

      <Modal
        title="Confirm Logout"
        desc="Are you sure you want to exit the admin system?"
        isModalOpen={isModalOpen}
        setIsOpen={setIsOpenModal}
        handleSubmit={handleLogoutClick}
        confirmButtonLabel="Logout Now"
        variant="danger"
        size="sm"
      />

      <ProfilePicture isOpen={isProfileOpen} setIsOpen={setIsProfileOpen} />
    </>
  );
}
